import { render, staticRenderFns } from "./memberSectionItem.vue?vue&type=template&id=835d2b70&scoped=true&"
import script from "./memberSectionItem.vue?vue&type=script&lang=js&"
export * from "./memberSectionItem.vue?vue&type=script&lang=js&"
import style0 from "./memberSectionItem.vue?vue&type=style&index=0&id=835d2b70&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835d2b70",
  null
  
)

export default component.exports